import { render, staticRenderFns } from "./HubCheckbox.vue?vue&type=template&id=1a9a1ab6&scoped=true&"
import script from "./HubCheckbox.vue?vue&type=script&lang=ts&"
export * from "./HubCheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./HubCheckbox.vue?vue&type=style&index=0&id=1a9a1ab6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9a1ab6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
